import React from 'react';
import './ZoneModal.scss';
import CircledTick from 'admin/common/icons/sidebar/CircledTick';
import { useTranslation } from 'react-i18next';

export default function ZoneModal({ setOpenModal, popupContent, onConfirm }) {
  const { t } = useTranslation();
  const isDeleteModal = Boolean(popupContent?.type);
  const confirmLabel =
    popupContent?.confirmLabel ||
    (isDeleteModal ? t('Delete') : t('Submit'));

  return (
    <div
      className="zonemodal"
      role="presentation"
      onClick={() => setOpenModal(false)}
    >
      <div
        className={`zonemodal__dialog${
          isDeleteModal ? ' zonemodal__dialog--delete' : ''
        }${popupContent?.withicon ? ' zonemodal__dialog--with-icon' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="zone-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        {popupContent?.withicon ? (
          <div className="zonemodal__icon">
            <CircledTick type="i" />
          </div>
        ) : null}

        <div className="zonemodal__body">
          <div className="zonemodal__copy">
            <h2 id="zone-modal-title" className="zonemodal__title">
              {popupContent?.header || t('Are you sure')}
            </h2>
            {popupContent?.subheader || popupContent?.subline2 ? (
              <p className="zonemodal__description">
                {popupContent?.subheader}
                {popupContent?.subline2 ? (
                  <>
                    <br />
                    {popupContent.subline2}
                  </>
                ) : null}
              </p>
            ) : null}
          </div>

          <div className="zonemodal__actions">
            <button
              type="button"
              className="zonemodal__btn zonemodal__btn--cancel"
              onClick={() => setOpenModal(false)}
            >
              {popupContent?.cancelLabel || t('Cancel')}
            </button>
            <button
              type="button"
              className={`zonemodal__btn ${
                isDeleteModal
                  ? 'zonemodal__btn--delete'
                  : 'zonemodal__btn--submit'
              }`}
              onClick={() => onConfirm(popupContent?.type)}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
